import { NavLink } from "react-router-dom";

const NAV = [
  { to: "/admin-dashboard", label: "Dashboard" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/companies", label: "Companies" },
  { to: "/admin/deals", label: "Deals" },
  { to: "/admin/submissions", label: "Submissions" },
  { to: "/admin/messages", label: "Messages & Chat" },
  { to: "/admin/calls", label: "Calls & Meetings" },
  { to: "/admin/documents", label: "Documents" },
  { to: "/admin/partners", label: "Partners" },
  { to: "/admin/operations", label: "Operations" },
  { to: "/admin/calendar", label: "Calendar" },
  { to: "/admin/finance", label: "Finance" },
  { to: "/kpi-dashboard", label: "KPIs" },
];

export default function SidebarShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-brand-gradient text-white">
      <div className="flex">
        {/* Sidebar */}
        <aside className="w-[250px] shrink-0 border-r border-white/10 p-4">
          <div className="flex items-center gap-3 px-2 py-3 mb-4">
            {/* Logo */}
            <img src="/images/acquizgroup-logo.png" alt="AcquizGroup" className="h-20 w-auto object-contain" />
          </div>
          <nav className="space-y-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-lg ${isActive ? "bg-white/10" : "hover:bg-white/5"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Main */}
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
}
